var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApDesignIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H35C40.5228 0 45 4.47715 45 10V35C45 40.5228 40.5228 45 35 45H10C4.47715 45 0 40.5228 0 35V10Z",
    fill: "#EDF7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 34.0002V28.6668C11 27.612 11.3128 26.5809 11.8988 25.7038C12.4849 24.8267 13.3178 24.1431 14.2924 23.7395C15.2669 23.3358 16.3392 23.2302 17.3738 23.436C18.4084 23.6418 19.3587 24.1497 20.1046 24.8956C20.8504 25.6415 21.3584 26.5918 21.5642 27.6264C21.77 28.6609 21.6644 29.7333 21.2607 30.7078C20.857 31.6823 20.1734 32.5153 19.2964 33.1013C18.4193 33.6874 17.3882 34.0002 16.3333 34.0002H11Z",
    stroke: "#429FF2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0003 10C31.1947 10.5205 27.6002 12.0589 24.5963 14.4526C21.5924 16.8463 19.2905 20.0067 17.9336 23.6",
    stroke: "#429FF2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0004 10C34.4799 13.8056 32.9415 17.4 30.5478 20.4039C28.1541 23.4078 24.9937 25.7097 21.4004 27.0667",
    stroke: "#429FF2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1338 18C23.7247 19.1958 25.8046 21.2758 27.0005 23.8667",
    stroke: "#429FF2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApDesignIcon);
export default __webpack_public_path__ + "static/media/ap-design-icon.36fdadd480dee28a5625164a640c1bce.svg";
export { ForwardRef as ReactComponent };